import React, { Component } from 'react';
import _ from 'underscore';
import { Badge, Media } from 'react-bootstrap';
import { Avatar } from '../../ui';
import { mixinsClassName, substrByBytes, dateUtil, getAttr, urls } from '../../utils';

export default class extends Component {
    genDesc(msg, is_group) {
        if (!msg || !msg.body) return '';

        let desc = is_group ? msg.nick_name + ': ' : '';
        let body = msg.body;

        switch (body.type) {
            case 'image':
                return desc + '[图片]';
            case 'file':
                return desc + '[文件]';
            default:
                return desc + (body.content || '');
        }
    }

    onClose(ev) {
        ev.stopPropagation();

        const { data, onClose } = this.props;
        onClose && onClose(data);
    }

    render() {
        const { data, userData, onClick, onDoubleClick } = this.props;
        const is_group = data.session_type === 'group';
        const className = mixinsClassName(
            'item-' + data.session_type,
            data.is_active ? 'active' : '',
            this.props
        );
        let desc = this.genDesc(data.last_msg, is_group);
        let avatarProps = {};

        if (is_group) {
            avatarProps.src = data.avatar || urls.imageRoot + 'group.png';
        } else {
            avatarProps = {
                src: data.avatar,
                text: data.name,
                className: getAttr(_.find(userData, { jid: data.jid }), 'status')
            };
        }

        return (
            <Media className={className} 
                   onClick={onClick&&onClick.bind(this, data, 'session')} 
                   onDoubleClick={onDoubleClick&&onDoubleClick.bind(this, data, 'session')}>
                <Media.Left>
                  <a className='icon icon-close' onClick={this.onClose.bind(this)}></a>
                  <Avatar {...avatarProps}/>
                </Media.Left>
                <Media.Body>
                  <Media.Heading>{substrByBytes(data.name, 17)}</Media.Heading>
                  <p>{substrByBytes(desc, 22)}</p>
                  <div className='pull-right'>
                    { dateUtil(data.updated_at).shortFormat('hh:mm', 'small') }<br/>
                    {
                        data.unread_count ?
                        <Badge className='mgt-xxs'>{data.unread_count}</Badge> :
                        null
                    }
                  </div>
                </Media.Body>
            </Media>
        );
    }
}


// WEBPACK FOOTER //
// ./src/session/item/index.js